import React from "react";
import { RefreshCw, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useDeferredReload } from "@/hooks/useDeferredReload";

/* Sin UI mientras es posible recargar de forma silenciosa.
 * Solo muestra un toast cuando la versión vieja lleva varias horas activa
 * (hard-deadline) y aún no se logró un momento seguro. */
export default function DeferredReloadManager() {
  const { showLastResortToast, dismissLastResort, reloadNow } = useDeferredReload();
  const { t } = useTranslation();

  if (!showLastResortToast) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 px-4 py-3 rounded-xl border border-altiv-navy/40 bg-[#0a0f1a]/95 backdrop-blur shadow-xl shadow-black/40 text-sm text-white">
      <RefreshCw className="w-4 h-4 text-slate-400 shrink-0" />
      <span className="text-white/80">{t("updateToast.message")}</span>
      <button
        onClick={reloadNow}
        className="px-3 py-1 rounded-lg btn-tier1 text-xs font-medium transition-colors"
      >
        {t("updateToast.reload")}
      </button>
      <button
        onClick={dismissLastResort}
        className="text-white/40 hover:text-white/70 transition-colors"
        aria-label={t("common.close")}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
